import { DialogService, UiHelpersService, UiModule } from '@shared/ui';
import { ExportHelpers } from 'apps/phoenix/src/app/shared/ui/services/export-helper/export-helper.service';

import { Component, Input, Renderer2, inject } from '@angular/core';

@Component({
  selector: 'phoenix-attachment',
  imports: [UiModule],
  template: `
    @if (
      attachment.type.includes('image') || attachment.type === 'application/pdf'
    ) {
      <div class="w-full flex justify-center">
        <a
          (click)="$event.stopPropagation()"
          [href]="attachment.full"
          [ngClass]="{
            'w-full': !heightLimit,
          }"
          target="_blank"
        >
          <img
            [ngClass]="
              heightLimit
                ? ' max-h-[100vh] object-cover m-auto'
                : 'object-fill w-full'
            "
            class="my-2"
            alt="Conversation attachment - image"
            [matTooltip]="'Open in a separate tab'"
            [src]="attachment.full"
            (error)="imgError()"
          />
        </a>
      </div>
    }
    <button
      mat-fab
      [matTooltip]="attachment.name"
      color="primary"
      type="button"
      extended
      class="flex items-center p-2 rounded-lg m-1 max-w-[50%]"
      (click)="$event.stopPropagation(); downloadAttachment()"
    >
      <mat-icon>cloud_download</mat-icon>
      <div class="flex items-center">
        <div class="flex flex-col">
          <small class="truncate text-xs">{{ attachment.type }}</small>
        </div>
      </div>
    </button>
  `,
})
export class AttachmentComponent {
  @Input() attachment!: any;
  @Input() heightLimit = true;

  dialogService = inject(DialogService);
  uiHelper = inject(UiHelpersService);
  renderer = inject(Renderer2);

  imgError() {
    if (this.attachment) {
      this.attachment.full = this.uiHelper.placeholderPath;
    }
  }

  downloadAttachment() {
    if (!this.attachment?.download) return;

    this.dialogService
      .confirm(
        `Are you sure you want to download this attachment <span class="break-words">${this.attachment?.name ?? 'file'}</span>?`,
        {
          width: '35%',
        }
      )
      .afterClosed()
      .subscribe(result => {
        if (result) {
          ExportHelpers.downloadLink(this.renderer, this.attachment.download);
        }
      });
  }
}
